export const minorUnits = {
  CZK: 100,
};
